import { render, staticRenderFns } from "./ClassificationVisits.vue?vue&type=template&id=521cd2e8"
import script from "./ClassificationVisits.vue?vue&type=script&lang=js"
export * from "./ClassificationVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports